import { render, staticRenderFns } from "./WorkFloInterventionForm.vue?vue&type=template&id=a2bf9b54&"
import script from "./WorkFloInterventionForm.vue?vue&type=script&lang=js&"
export * from "./WorkFloInterventionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports